import { render } from "./ProfileJokes.vue?vue&type=template&id=32e62076&scoped=true"
import script from "./ProfileJokes.vue?vue&type=script&lang=js"
export * from "./ProfileJokes.vue?vue&type=script&lang=js"

import "./ProfileJokes.vue?vue&type=style&index=0&id=32e62076&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e62076"]])

export default __exports__